<template>
	<v-container>
		
		<v-row
			class 	= "mt-5"
			justify = "center"
			align 	= "center"
		>
			<v-col
				cols = "5"
			>
				<v-card 
					outlined
					:loading = "loading"
				>
					<v-card-title
						:class = "head.class_title"
					>
						{{ head.title }}
					</v-card-title>
					<v-card-text
						:class = "head.class_text"
					>
						{{ head.text}} ...
					</v-card-text>
				</v-card>
			</v-col>

		</v-row>
	</v-container>
</template>
<script>
	export default{
		name : "page_not_found",
		data : (vm) => ({
			info : {},
			head : {
				title 		: vm.$ml.get('page_not_found'),
				class_title : "justify-center pa-1 body-1 text-h4 warning",
				text  		: vm.$ml.get("redirecting_page"),  
				class_text  : "pa-2 body-2 text-h5"
			},
			loading 		: true,
		}), // data

		created(){		
			if (this.$route && this.$route.path.includes("not_access_view")) {
				this.head.title = this.$ml.get("no_have_permission_view");
			}
		}, // created
		
		mounted(){
			const timer = setTimeout(()=>{
				if (this.$route.path !== '/') {
					this.$router.push({ path : "/"}).catch(err => {
						if (err.name !== 'NavigationDuplicated') throw err;
					});
				}
				clearTimeout(timer);
			},3500)
		}, // mounted
	}
</script>